import { Inject, Injectable } from '@angular/core';
import { animationFrameScheduler, fromEvent, merge, NEVER, Observable } from 'rxjs';
import { share, startWith, throttleTime } from 'rxjs/operators';

import { WINDOW } from './window.providers';

@Injectable({
  providedIn: 'root',
})
export class ActivityService {
  public readonly events$ = this.createEventsObservable();

  constructor(@Inject(WINDOW) private readonly win: Window) {}

  private createEventsObservable(): Observable<Event> {
    if (!this.win) {
      return NEVER;
    }

    const THROTTLE_TIMER = 60000; // TODO * Move this const on global variable for CI

    return merge(
      fromEvent(this.win.document, 'click'),
      fromEvent(this.win.document, 'keydown'),
      fromEvent(this.win.document, 'mousemove'),
      fromEvent(this.win.document, 'scroll'),
    ).pipe(startWith({ type: 'init' } as Event), throttleTime(THROTTLE_TIMER, animationFrameScheduler), share());
  }
}
